module.exports = __webpack_public_path__ + "resources/img/img_csap_saas_guide.a442b19ba8e153a005c389f6e76476e5.png";